// react library imports
import { Heart } from 'phosphor-react';
import { motion } from 'framer-motion';
import { useDispatch } from 'react-redux';

// style imports and main component imports
import {VideoPlayer} from 'Component';
import './Product.css';

// imports from utils
import { headingAnimation, useAnimationHook } from 'Utils/animation';

// redux store imports
import { openSchedule, openDownloadPopup, openNavigationPopup } from 'Redux/popup/popup';

const Product = ({data, name, isShow, btn1}) => {
    // custom hook for animation
    const {ref, mainControls}=useAnimationHook(0.5)

    // define dispatch action from redux store
    const dispatch = useDispatch()
  return (
    <motion.div ref={ref} className={`teacher_main_product_container padding_container ${data.background}`}
    initial="hidden" animate={mainControls} transition={{staggerChildren:0.1}}>
        <motion.div className={`teacher_main_product_video_container ${data.shadow}`} variants={headingAnimation}>
            <VideoPlayer thumbnail={data.thumbnail} src={data.video}
            className="product_video_player_icon"/>
        </motion.div>
        <div className='teacher_main_product_info_container mues_white'>
            <div className='teacher_main_product_info'>
                <motion.div className='mues_row_flex mues_column_gap_8'
                variants={headingAnimation}>
                    <h2 className='mues_font_weight_700'>{data.title.one}</h2>
                    <Heart className='teacher_main_product_icon' weight='fill'/>
                    <h2 className='mues_font_weight_700'>{data.title.two}</h2>
                </motion.div>
                <motion.h5 className='mues_font_weight_500' dangerouslySetInnerHTML={{__html:data.description}}
                variants={headingAnimation}/>
            </div>
            {!isShow && <motion.div className='mues_row_center mues_column_gap_16'
            variants={headingAnimation}>
                {btn1 ? <button className='btn mues_white_background' onClick={()=>dispatch(openNavigationPopup(name))}>{btn1}</button>:<button className='btn mues_white_background'
                onClick={()=>dispatch(openDownloadPopup(name))}>Download the App</button>}
                <button className='btn mues_white_background'
                onClick={()=>dispatch(openSchedule())}>Schedule a call</button>
            </motion.div>}
        </div>
    </motion.div>
  )
}

export default Product